const developmentNameRe = /([_-]dev$)|(^dev[_-])|([_-]development$)|(^development[_-])/;
const productionNameRe = /([_-]prod$)|(^prod[_-])|([_-]production$)|(^production[_-])/;
const stagingNameRe = /([_-]stg$)|(^stg[_-])|([_-]staging$)|(^staging[_-])|([_-]test$)|(^test[_-])|([_-]uat$)|(^uat[_-])|([_-]qa$)|(^qa[_-])/;

const getTenantTaggingSuggestion = name => {
  if (name && developmentNameRe.test(name)) {
    return 'development';
  } else if (name && stagingNameRe.test(name)) {
    return 'staging';
  } else if (name && productionNameRe.test(name)) {
    return 'production';
  }

  return null;
};

export default getTenantTaggingSuggestion;
